import React from "react";
import storeContext from "src/stores";

const useStores = () => React.useContext(storeContext);

export default useStores;
